import * as UsersAPI from '../api/Users.api';
import UserItemSchema from 'Shared/utils/normalizeJSON/schemas/User.schema';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import UsersConstants from '../constants/Users.constants';

import { addObjectToFormData } from 'Shared/helpers';
import { tr } from 'Shared/utils/hooks/use-translation';

export const fetchUserBySlugSuccess = payload => ({
  type: UsersConstants.Actions.FETCH_USER_BY_ID_SUCCESS,
  payload,
});

export const updateUserSuccess = payload => ({
  type: UsersConstants.Actions.UPDATE_USER_SUCCESS,
  payload,
});

export const updateUserPhotoSuccess = payload => ({
  type: UsersConstants.Actions.UPDATE_USER_PHOTO_SUCCESS,
  payload,
});

export const updateUserFlagSuccess = payload => ({
  type: UsersConstants.Actions.UPDATE_USER_FLAG_SUCCESS,
  payload,
});

export const fetchUserBySlug = slug => dispatch => {
  return UsersAPI.fetchUserBySlug(slug).then(response => {
    dispatch(fetchUserBySlugSuccess(normalizer(UserItemSchema, response.data)));
    return response;
  });
};

export const updateUser =
  ({ id, data }) =>
  dispatch => {
    return UsersAPI.updateUser(id, data)
      .then(response => {
        WpToastManager.success(tr('perform.common.update_successful'));
        dispatch(updateUserSuccess(normalizer(UserItemSchema, response.data)));
        return response;
      })
      .catch(error => {
        return error.response.data.error;
      });
  };

export const updateUserPhoto = file => dispatch => {
  const data = new FormData();
  addObjectToFormData(data, file, 'profile_picture');

  return UsersAPI.updateUserPhoto(data)
    .then(response => {
      WpToastManager.success(tr('perform.common.update_successful'));
      dispatch(updateUserPhotoSuccess(normalizer(UserItemSchema, response.data)));
      return response;
    })
    .catch(error => {
      return error.response.data.error;
    });
};

export const updateUserFlag = (flag, value) => dispatch => {
  const data = {
    flag,
    value,
  };
  return UsersAPI.updateUserFlag(data)
    .then(response => {
      dispatch(updateUserFlagSuccess(data));
      return response;
    })
    .catch(error => {
      return error.response.data.error;
    });
};

export const createAddToWaitlist = ({ id, data }) => {
  return UsersAPI.createAddToWaitlist({ id, data });
};
